



































































































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { ViewDataFromEmailApi } from '@/api'
import NotificationWithOutExit from "@/components/common/notification/NotificationWithOutExit.vue"
import { config } from '../../config'

@Component({
    components: {
        'common-notification-notification': NotificationWithOutExit
    }
})
export default class EmailTransferDetail extends Vue {
    loading: boolean = false
    
    isData: boolean = false
    strEmailType: string = ""
    projectName: string = ""
    lsUnit: any[] = []
    urlLoginInvoice: string = ""


    async mounted() {
        await this.SetGetReportEmailTransferDetail()
    }

    async SetGetReportEmailTransferDetail() {
        try {
            this.loading = true
            const qs = this.$route.query
            const unitId = qs.unitid ?? ""

            this.strEmailType = "ข้อมูล" 
            this.urlLoginInvoice = "http://sansiriapp.sansiri.com/tracking"


            const response = await ViewDataFromEmailApi.GetEmailTransferDetail({ unitid: unitId })
            
            if (response != undefined)
            {
                if (response.length)
                {
                    this.projectName = response[0].projectName

                    // const siriDoc = "http://webdevteam1.sansiri.com/siridocument"
                    // const userId = "1646"
                    // const userCode = "sys_TransferPlanning"
                    // const tailStr = "&user_id=" + userId + "&user_code=" + userCode + "&unit_code=" + response[0].unitCode + "&unit_id=" + response[0].unitId + "&ProjectName=" + this.projectName + "&Project_id=" + response[0].projectId + "&Prospect_id=" + response[0].prospectId + "&ProspectName=" + response[0].prospectName
                    // this.urlAttachFile =  siriDoc + "/Prospect_popupAttfile_Edit.aspx?" + tailStr

                    // const wordSplit = response[0].unitCode.split('-');
                    // const crmPath = "http://sansiriapp3.sansiri.com/quotation" 
                    // this.urlInvoice =  crmPath + "/Report/Rpt_PayTrans.aspx?PJ=" +  wordSplit[0] + "&Unit_id=" + response[0].unitId + "&SAPCustomer_Num=" + response[0].contractNum 
                }
            }

            this.lsUnit = response

            this.loading = false
            this.isData = true

        } catch (error) {
            this.isData = false
            this.notification('มีข้อผิดพลาดเกิดขึ้น โปรดลองใหม่อีกครั้ง', 'warning') 
        }
    }

    openLinkSiriDocument (item: any) {
        const paramsJson = {
            user_id: "1646",
            user_code: "sys_TransferPlanning",
            unit_code: item.unitCode,
            unit_id: item.unitId,
            ProjectName: item.projectName,
            Project_id: item.projectId,
            Prospect_id: item.prospectId,
            ProspectName: item.prospectName
        }
        const searchParams = new URLSearchParams(paramsJson);
        const queryString = searchParams.toString();
        const url = `${config.siriApp4Url}/siridocument/Prospect_popupAttfile_Edit.aspx?${queryString}`
        window.open(url, '_blank')
    }

    openLinkQuotation (item: any) {
        const paramsJson = {
            PJ: item.unitCode.split("-")[0],
            Unit_id: item.unitId,
            SAPCustomer_Num: item.contractNum ?? ""
        }
        const searchParams = new URLSearchParams(paramsJson);
        const queryString = searchParams.toString();
        const url = `${config.siriApp3Url}/quotation/Report/Rpt_PayTrans.aspx?${queryString}`
        window.open(url, '_blank')
    }

    notification (text: string, status: string) {
        const child = this.$refs.refNotification as any
        child.openNotification(text, status)
    }
}

